import { cn } from "@omni/utils/styles";

import { Count } from "./components/count/count.component";
import { Locales } from "./components/locales/locales.component";
import { SelectedFilters } from "./components/selectedFilters/selectedFilters.component";
import { Sort } from "./components/sort/sort.component";

export const Filters = () => {
    return (
        <div
            className={cn(
                "tw:flex tw:flex-col tw:pb-4 tw:mb-4 tw:bg-background tw:border-b tw:border-b-grey-light"
            )}
        >
            <div
                className={cn(
                    "tw:w-full tw:flex tw:flex-col tw:gap-2 tw:pt-4",
                    "tw:md:flex-row tw:md:justify-between tw:md:items-center"
                )}
            >
                <div>
                    <Count />
                </div>
                <div
                    className={cn("tw:flex tw:flex-row tw:gap-4 tw:md:ml-auto")}
                >
                    <Locales
                        className={cn(
                            "tw:flex-1 tw:shrink tw:grow tw:w-full",
                            "tw:md:flex-[250px] tw:md:shrink-0 tw:md:grow-0 tw:md:w-auto"
                        )}
                    />
                    <Sort
                        className={cn(
                            "tw:flex-1 tw:shrink tw:grow tw:w-full",
                            "tw:md:flex-[250px] tw:md:shrink-0 tw:md:grow-0 tw:md:w-auto"
                        )}
                    />
                </div>
            </div>
            <div className={cn("tw:flex tw:flex-wrap tw:items-center")}>
                <SelectedFilters />
            </div>
        </div>
    );
};
